
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.663 41.632V7.565a4.536 4.536 0 00-4.53-4.53h-4.265c.783 1.17 1.261 2.756 1.261 4.53v30.09c0 .457-.306.859-.747.98l-10.814 2.997h19.095zM23.483 3.035h-8.917a4.534 4.534 0 00-4.53 4.53l.058 33.747 15.999-4.431V7.565c0-2.413-1.22-4.53-2.61-4.53zM31.133 1a6.572 6.572 0 016.565 6.565V42.65c0 .562-.456 1.017-1.018 1.017H9.02c-.092 0-.173-.03-.258-.051-.002 0-.004 0-.005-.002A1.003 1.003 0 018 42.65V7.565l.001-.005C8.003 3.88 10.044 1 12.647 1h18.486zM18.065 9.58a2.967 2.967 0 00-2.964 2.963 2.967 2.967 0 002.964 2.963 2.967 2.967 0 002.963-2.963 2.967 2.967 0 00-2.963-2.964zm-5 2.963a5.004 5.004 0 015-5 5.004 5.004 0 014.997 5 5.003 5.003 0 01-4.997 4.998c-2.758 0-5-2.241-5-4.998zm8.28 10.2l-.019-.1c.603-.265 1.21-.5 1.824-.71.308-.103.597-.293.926-.28.328.007.664.055 1.031.27l.02.1c-.263.336-.558.503-.86.63-.301.133-.642.064-.965.08-.646.031-1.298.034-1.956.01z"}})])
          )
        }
      }
    